import { CART_MODULE } from "@/api_framework/api_config";
import { IUrgentCancelDraftCart, IUrgentCancelDraftCartResponse } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export type IUrgentCancelDraftCartResult = {
  status: boolean;
  draftCart: IUrgentCancelDraftCart | null;
};

/** Reads the current state of an urgent-cancel draft cart for a session. */
export const useUrgentCancelDraftCartAPI = () => {
  const configuration = useConfiguration();
  const [draftCartData, setDraftCartData] = useState<IUrgentCancelDraftCart | null>(null);
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async (sessionId: string): Promise<IUrgentCancelDraftCartResult> => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response: IUrgentCancelDraftCartResult = await axios
        .get(`${CART_MODULE?.URGENT_CANCEL_CART?.baseURL}?session_id=${sessionId}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IUrgentCancelDraftCartResponse>) => {
          if (res.data.status === true) {
            setDraftCartData(res.data.data);
            return { status: true, draftCart: res.data.data };
          }
          setDraftCartData(null);
          return { status: false, draftCart: null };
        })
        .catch((e: AxiosError) => {
          setDraftCartData(null);
          sendCurl(e.config?.["curlCommand"]);
          captureError(e);
          return { status: false, draftCart: null };
        });
      return response;
    } catch (e: any) {
      setDraftCartData(null);
      captureError(e);
      return { status: false, draftCart: null };
    }
  }, []);

  return { draftCartData, execute };
};
